import { AlertType } from 'common/src/types/enums/AlertType.enum';

import { NON_THEME_COLORS } from 'portal/src/theme/constants';

export function getAlertTypeColor(alertType: AlertType): string {
  const { blue, green, orange, purple, pink, teal, deepPurple, gray } =
    NON_THEME_COLORS;

  const colorMap: Record<AlertType, string> = {
    [AlertType.Allocations]: blue,
    [AlertType.BillAutomation]: green,
    [AlertType.DataIngest]: orange,
    [AlertType.DataInsights]: purple,
    [AlertType.EnergyStar]: pink,
    [AlertType.IntervalData]: teal,
    [AlertType.Reporting]: deepPurple,
  };

  return colorMap[alertType] || gray;
}
